import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

import { winnerLayouts } from '../../../common/enums/index.js';

import WinnerActions from '../winner-actions';

const initialState = Immutable({
  layout: winnerLayouts.LIST,
});

const reducer = createReducer((on) => {
  on(WinnerActions.toggleLayout, (state, { layout }) => {
    return state.set('layout', layout);
  });
}, initialState);

export default reducer;
